import { render, staticRenderFns } from "./SplitValueInputField.vue?vue&type=template&id=4cd5e0e7&scoped=true"
import script from "./SplitValueInputField.vue?vue&type=script&lang=ts"
export * from "./SplitValueInputField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5e0e7",
  null
  
)

export default component.exports